import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AppService, AppSettingService, AppUtilityService } from '../app.service';
import { UserInfoService, IUserProfile } from '../user/user-info.service';
import { WebAPIService } from '../user/user-api.service';
import { AccountAPIService } from '../user/account-api.service';
import { AnonymousUserService } from '../user/anonymousUser/anonymous-user.service';
import { ZoneAPIService } from '../zone/zone-api.service';
import { WidgetAPIService } from '../widget/widget-api.service';

@Component({
	selector: 'app-navigation-header',
	templateUrl: './navigation-header.component.html',
	styleUrls: ['./navigation.component.scss'],
	standalone: false
})
export class NavigationHeaderComponent implements OnInit {
	constructor(
		private accountAPI: AccountAPIService,
		private anonymousSrv: AnonymousUserService,
		public appSetting: AppSettingService,
		private appSrv: AppService,
		private location: Location,
		private router: Router,
		public userInfo: UserInfoService,
		private webAPI: WebAPIService,
		public widgetAPI: WidgetAPIService,
		private zoneAPI: ZoneAPIService
	) { }

	defaultLogo: string = 'assets/images/JourneysLogo.png';
	defaultLogoMobile: string = 'assets/images/JourneysLogoMobile.png';
	logo: any = null;
	user: IUserProfile = null;
	personInfo: any = null;
	loggedIn: boolean = false;
	isAnonymous: boolean = true;
	allowSignup: boolean = false;
	isSystemAdmin: boolean = false;
	zoneName: string = '';
	pathName: string = '';
	profileImage: string = "assets/images/userImage.png";
	profileReady: boolean = false;
	defaultLogoMobileThresh: number = 430;

	@HostListener('window:resize', ['$event']) onResize(event: any) {
		this.setDefaultLogo();
	}

	private accountMonitor: Subscription;

	setDefaultLogo() {
		if (window.innerWidth < this.defaultLogoMobileThresh) {
			this.logo = this.defaultLogoMobile;
		} else {
			this.logo = this.defaultLogo;
		}
	}

	goto(url: string): void {
		if (url === 'openSignup') {
			this.anonymousSrv.openSignupLogin("signup", "", false, "", null);
		}
		else if (url === 'openLogin') {
			this.anonymousSrv.openSignupLogin("login", "", false, "", null);
		}
		else if (url === "help") {
			window.open("https://intercom.help/journeys-acc277045d6d", "_blank");
		}
		else if (url === "dashboard") {
			let homepage: string = this.userInfo.getHomePage().trim().toLowerCase();
			if (homepage.indexOf("user/profileDashboard") > -1
				|| homepage.indexOf("employer/dashboard") > -1
				|| homepage.indexOf("activity/self") > -1
			) {
				this.appSrv.goTo(this.userInfo.getHomePage());
			}
			else {
				this.router.navigateByUrl("/User/ProfileDashboard");
			}
		}
		else if (this.userInfo.isAnonymous() && url != "/Map") {
			this.anonymousSrv.openSignupLogin("login", url, true, "", null);
		}
		else {
			if (url === "/Map" && this.router.url === "/Map") {
				this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
					this.router.navigateByUrl(url);
				});
			} else {
				this.router.navigateByUrl(url);
			}
		}
	};

	loadingWeb: boolean = false;
	gotoWeb(): void {
		if (!this.userInfo.isSystemAdmin) {
			return;
		}
		this.loadingWeb = true;
		this.webAPI.signOn().subscribe({
			next: () => {
				window.location.href = "/Users/PersonEdit.aspx";
				this.loadingWeb = false;
			},
			error: (err: any) => {
				this.loadingWeb = false;
				console.log(err);
			}
		});
	}


	logout(): void {
		this.userInfo.clearProfile(true);
	}

	getProfilePhoto(): void {
		this.accountAPI.getMyProfile().subscribe({
			next: (response: any) => {
				this.profileImage = response.Photo;
			},
			error: (error: any) => {
				console.log(error);
			}
		});
	};

	goHomehLink(): void {
		if (this.userInfo.getHomePage() != '') {
			this.appSrv.goTo(this.userInfo.getHomePage());
		}
	}

	storedLocation = this.location.path();

	private loadUserInfo(): void {
		this.personInfo = null;
		this.user = this.userInfo.getProfile();
		this.loggedIn = this.userInfo.isLogin();
		this.isAnonymous = this.userInfo.isAnonymous();
		this.allowSignup = this.userInfo.allowSignup();
		this.zoneName = this.userInfo.zoneName;

		if (!this.isAnonymous) {
			this.isSystemAdmin = this.userInfo.isSystemAdmin;
			this.personInfo = this.user;
			this.getProfilePhoto();
		}
		else {
			this.isSystemAdmin = false;
		}
		this.profileReady = true;
	}

	private loadLogo(): void {
		this.zoneAPI.getZoneByName(this.zoneName).subscribe({
			next: (response: any) => {
				if (response.Logo.toLowerCase().indexOf('journeyslogo.png') > 0) {
					this.setDefaultLogo();
				}
				else {
					this.logo = response.Logo;
				}
			},
			error: (error: any) => {
				console.log(error);
				this.setDefaultLogo();
			}
		});
	}

	ngOnDestroy() {
		if (this.accountMonitor) {
			this.accountMonitor.unsubscribe();
		}
	}

	ngOnInit(): void {
		//watch session change
		this.accountMonitor = this.userInfo.UserInfoTimestamp.subscribe({
			next: () => {
				this.loadUserInfo();
				this.loadLogo();
			},
			error: (err: any) => {
				console.log(err);
				this.loadUserInfo();
				this.loadLogo();
			}
		});
	}
}


@Component({
	selector: 'app-navigation-footer',
	templateUrl: './navigation-footer.component.html',
	styleUrls: ['./navigation.component.scss'],
	standalone: false
})
export class NavigationFooterComponent {
	currentYear: number = (new Date()).getFullYear();
}


@Component({
	selector: 'app-navigation-idle',
	templateUrl: './navigation-idle.component.html',
	standalone: false
})
export class NavigationIdleComponent implements OnInit, OnDestroy {
	idleState = 'Not started.';
	timedOut = false;
	lastPing?: Date = null;
	idleCtrlId = '';
	idleWaring: any = null;
	closeWarning = false;
	private accountMonitor: Subscription;

	constructor(
		private userInfo: UserInfoService,
		private idle: Idle,
		private keepalive: Keepalive,
		public dialog: MatDialog,
		private router: Router,
	) {
		this.idle.setIdle(AppSettingService.idle.timeoutAfter);  //600 seconds
		this.idle.setTimeout(AppSettingService.idle.warningDuration); //60
		this.keepalive.interval(AppSettingService.idle.keepAlive); //30
		// sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
		this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
		this.idleCtrlId = AppUtilityService.newId();

		this.idle.onIdleStart.subscribe(() => {
			this.idleState = 'You\'ve gone idle!'

			if (this.userInfo.isAnonymous() === true) {
				this.stopWatch();
				return;
			}
			// already popup?, do nothing and get out now
			if (this.idleWaring != null) {
				return;
			}
			this.closeWarning = false;

			// popup the idle timeout warning and not allow any other activities
			this.idleWaring = this.dialog.open(
				NavigationIdleWarningComponent,
				{ maxWidth: '500px', disableClose: true, autoFocus: true }
			);
			this.idleWaring.afterClosed().subscribe((choice: any) => {
				this.idleWaring = null;
				if (choice === "logout") {
					this.logout();
				}
				else if (choice === "stay") {
					//announce users want to stay
					this.lastPing = new Date();
					localStorage.setItem("idleTime", JSON.stringify({ "ctrlId": this.idleCtrlId, "time": this.lastPing.toUTCString() }));
					try { clearInterval(checkAlive); }
					catch (ex) { ; }
					this.idle.watch();
				}
			});

			// check if any other tab still active
			var idleStart = new Date().toUTCString();
			var checkAlive = setInterval(() => {
				try {
					var idleTime = JSON.parse(localStorage.getItem("idleTime"));
					// close warning if the new time is found and not issued from self
					if (idleTime.ctrlId !== this.idleCtrlId && new Date(idleTime.time) > new Date(idleStart)) {
						clearInterval(checkAlive);
						this.closeWarning = true;
					}
				}
				catch (ex) { ; }
			}, 1000);
		});

		this.idle.onIdleEnd.subscribe(() => {
			this.idleState = 'No longer idle.'
			//do nothing
		});

		this.idle.onTimeout.subscribe(() => {
			this.idleState = 'Idle Timed out!';
			this.timedOut = true;
			// timeout redirect user to login page if user does login
			if (this.userInfo.isAnonymous() === true) {
				this.stopWatch();
			}
			else {
				this.logout();
			}
		});

		this.idle.onTimeoutWarning.subscribe((countdown) => {
			this.idleState = 'You will time out in ' + countdown + ' seconds!'
		});

		// function will be called when idle watch() is started. 
		// function will be stopped when IdleStart is called
		// the interval is set by KeepaliveProvider.interval
		this.keepalive.onPing.subscribe(() => {
			this.lastPing = new Date();

			if (this.userInfo.isAnonymous() === true) {
				this.stopWatch();
				return;
			}
			// if idleWarning popup not display, then update time
			if (this.idleWaring == null) {
				localStorage.setItem("idleTime", JSON.stringify({ "ctrlId": this.idleCtrlId, "time": this.lastPing.toUTCString() }));
				//console.log('keep alive: ' + JSON.parse(localStorage.getItem("idleTime")).time);
			}
		});
	}

	logout(): void {
		this.closeWarning = true;
		if (this.router.url.toLocaleLowerCase().indexOf("/landing/") >= 0) {
			this.userInfo.clearProfile(false);
		}
		else {
			this.userInfo.clearProfile(true);
		}
	}

	stopWatch(): void {
		//console.log("stop idle timeout monitor");
		if (this.idleWaring != null) {
			this.closeWarning = true;
		}
		if (this.idle.isRunning()) {
			this.idle.stop();
		}
	}

	startWatch(): void {
		if (!this.idle.isRunning()) {
			//console.log("start idle timeout monitor");
			this.idle.watch();
			this.idleState = 'Started.';
			this.closeWarning = true;
			this.timedOut = false;
		}
	}

	ngOnDestroy(): void {
		this.accountMonitor.unsubscribe();
		this.stopWatch();
	};

	ngOnInit(): void {
		if (!this.userInfo.isAnonymous()) {
			this.startWatch();
		}

		this.accountMonitor = this.userInfo.UserInfoTimestamp.subscribe({
			next: () => {
				if (this.userInfo.isAnonymous()) {
					this.stopWatch();
				}
				else {
					this.startWatch();
				}
			},
			error: (err: any) => {
				console.log(err);
			}
		});
	};
}


@Component({
	selector: 'app-navigation-idle-warning',
	templateUrl: './navigation-idle-warning.component.html',
	standalone: false
})
export class NavigationIdleWarningComponent {
	constructor(
		public dialogRef: MatDialogRef<NavigationIdleWarningComponent>
	) { }

	warningDuration: number = AppSettingService.idle.warningDuration;
	timeleft: number = this.warningDuration;
	warningProgress: number = 0;
	percent: string = '0';

	onNoClick(): void {
		this.dialogRef.close();
	}

	stayActive() {
		this.dialogRef.close("stay");
	};

	logout() {
		this.dialogRef.close("logout");
	}

	progressBar = setInterval(() => {
		this.timeleft = this.timeleft - 1;
		this.warningProgress = this.warningDuration - this.timeleft;
		this.warningProgress = this.warningProgress > this.warningDuration ? this.warningDuration : this.warningProgress;
		this.percent = (this.warningProgress / this.warningDuration * 100).toFixed(0);
		if (this.warningProgress === this.warningDuration) {
			clearInterval(this.progressBar);
			this.dialogRef.close("logout");
		}
	}, 1000);

	ngOnInit(): void {
	}
}


@Component({
	selector: 'app-navigation-error',
	templateUrl: './navigation-error.component.html',
	standalone: false
})
export class NavigationErrorComponent implements OnInit {
	constructor(
		private userInfo: UserInfoService,
		private router: Router
	) { }

	errorMessage: string = "";

	ngOnInit(): void {
		if (this.router.url.toLowerCase().indexOf("sso") > 0) {
			this.errorMessage = "We love your enthusiasm, but your Journeys Map account is still being created. Please check with your teacher to know when it will be ready!";
		}
		else if (this.router.url.toLowerCase().indexOf("stokenexp") > 0) {
			this.errorMessage = "The given SSO token is expired!";
		}
		else if (this.router.url.toLowerCase().indexOf("permission") > 0) {
			this.errorMessage = "Please check with your system admin to ensure your have right to access this function!";
		}
		else {
			if (this.userInfo.isAnonymous()) {
				this.router.navigateByUrl("/User/Login");
			}
			else {
				this.errorMessage = "The requested content is not found. Please ensure you have rights to access this page.";
			}
		}
	}
}


@Component({
	selector: 'app-navigation-home',
	templateUrl: './navigation-home.component.html',
	standalone: false
})
export class NavigationHomeComponent implements OnInit {
	constructor(
		public userInfo: UserInfoService,
		private appSrv: AppService
	) { }

	ngOnInit(): void {
		if (this.userInfo.isAnonymous()) {
			window.location.href = AppSettingService.baseUrl + "/User/Login";
		}
		else {
			if (this.userInfo.getHomePage() != '') {
				this.appSrv.goTo(this.userInfo.getHomePage());
			}
		}
	}
}


@Component({
	template: `<table class="w-100" style="height:100vh"><tr><td class="text-center align-middle"><div class="jmWidgetLoadingIcon40"></div></td></tr></table>`,
	standalone: false
})
export class ExternalLinkComponent implements OnInit {
	xLink: string = "";
	constructor(private route: ActivatedRoute) { }
	ngOnInit(): void {
		this.xLink = (this.route.snapshot.data["xLink"] ?? "").trim();
		if (this.xLink === "") {
			this.xLink = AppSettingService.baseUrl + "/User/Login";
		}
		window.location.href = this.xLink;
	}
}


@Component({
	selector: 'app-navigation-splash',
	template: `<div class="d-flex justify-content-center align-items-center vh-100"><span class="jmWidgetLoadingIcon40"></span></div>`,
	standalone: false
})
export class NavigationSplashComponent {
	constructor(private activeRoute: ActivatedRoute) { }
	private routeTo: string = "";

	ngOnInit(): void {
		this.activeRoute
			.queryParams
			.subscribe(
				params => {
					this.routeTo = (params["routeTo"] || "").trim();
					console.log(this.routeTo);
					if (this.routeTo !== "") {
						this.routeTo = this.routeTo + ((this.routeTo.indexOf("?") > 0) ? "&" : "?") + "tm=" + AppUtilityService.newId();
						window.location.href = this.routeTo;
					}
				}
			);
	}
}
